import { render, staticRenderFns } from "./DisposeCJSO.vue?vue&type=template&id=0498bd10"
import script from "./DisposeCJSO.vue?vue&type=script&lang=js"
export * from "./DisposeCJSO.vue?vue&type=script&lang=js"
import style0 from "./DisposeCJSO.vue?vue&type=style&index=0&id=0498bd10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports